import { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore } from "@/lib/api";

const AuthContext = createContext(null);

async function restoreSession(setUser, setLoading) {
    if (!tokenStore.get()) {
        setUser(false);
        setLoading(false);
        return;
    }
    try {
        const { data } = await api.get("/auth/me");
        setUser(data);
    } catch (err) {
        try {
            const { data } = await api.post("/auth/refresh");
            if (data.access_token) tokenStore.set(data.access_token);
            const me = await api.get("/auth/me");
            setUser(me.data);
        } catch (refreshErr) {
            console.error("Auth check failed:", err, refreshErr);
            tokenStore.clear();
            setUser(false);
        }
    } finally {
        setLoading(false);
    }
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking | false = guest | {} = user
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        restoreSession(setUser, setLoading);
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        tokenStore.set(data.access_token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (err) {
            console.warn("Logout request failed (clearing session anyway):", err);
        }
        tokenStore.clear();
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
